import {Chart as ChartJS, CategoryScale,   LinearScale,   PointElement,   LineElement,  Title,   Tooltip,  Legend,} from 'chart.js';
import { Line  } from "react-chartjs-2";
import { useState, useEffect } from 'react';
import Players from './Players';
import './Football.css';


ChartJS.register(  CategoryScale,  LinearScale,  PointElement,  LineElement,  Title,  Tooltip,  Legend);

const teamsData = {};

const getTeamIDs = async (setTeamsList) => {
    try{
        const response = await fetch("https://site.api.espn.com/apis/site/v2/sports/football/nfl/teams");
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        data.sports[0].leagues[0].teams.forEach(team => {
            teamsData[team.team.abbreviation] = {id: team.team.id, key: team.team.abbreviation, name: team.team.displayName, boxStats:{}, boxStatsOppo:{}}
        });
        setTeamsList(Object.keys(teamsData).map(key=>{ return {key, name: teamsData[key].name}}));
    }catch(err){
        console.log(err);
    }
}

const getTeamSchedule = async (teamKey) => {
    try{
        const teamID = teamsData[teamKey].id;
        const response = await fetch(`https://site.api.espn.com/apis/site/v2/sports/football/nfl/teams/${teamID}/schedule?seasontype=2`);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        teamsData[teamKey].games = data.events;
    }catch(err){
        console.log(err)
    }
}

const getBoxScore = async (gameID, weekNum) => {
    try{
        const response = await fetch(`https://cdn.espn.com/core/nfl/boxscore?xhr=1&gameId=${gameID}`);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        if (data.gamepackageJSON.boxscore.players) {
            processBoxScore(data.gamepackageJSON.boxscore.players, weekNum);
            return weekNum
        }else{
            return -1;
        }
    }catch(err){
        console.log(err)
    }
}

const processBoxScore= (boxscore, weekNum) => {
    boxscore.forEach( (entry, idx)=>{
        let team = teamsData[entry.team.abbreviation];
        if (team.boxStats[weekNum]) return;
        let gameStats={};
        for(let i = 0; i<=2; i++){  //passing, receiving, rushing
            let stats = entry.statistics[i];
            gameStats[stats.name] = {labels: stats.descriptions, players: stats.athletes, totals: stats.totals};
            gameStats.teamLabel = entry.team.abbreviation;
        }
        team.boxStats[weekNum] = gameStats;
        
        let opponent = boxscore[idx == 0 ? 1 : 0].team.abbreviation;
        teamsData[opponent].boxStatsOppo[weekNum] = gameStats
    });
}

const options = {
    scales: {
      y: {
        min: 0, // minimum value for y-axis
        max: 500, // maximum value for y-axis
        title: {
          display: true,
          text: 'Yards',
          rotation: 90,
          font: {
            size: 16,
            weight: 'bold'
          }
        }
      }
    }
  };

const Football = props =>{
    const [teamsList, setTeamsList] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState();
    const [chartData, setChartData] = useState({});
    const [showFor, setShowFor] = useState(false);
    const [tableData, setTableData] = useState({});

    const dataSetsAgainst = [
        {
            label: 'Receiving Against',
            data: chartData.receivingAgainst,
            borderColor: 'rgba(204, 98, 207, 1)',
        },
        {
            label: 'Rushing Against',
            data: chartData.rushingAgainst,
            borderColor: 'rgb(75, 192, 192)',
        }
    ];

    const dataSetsFor = [
        {
            label: 'Receiving For',
            data: chartData.receivingFor,
            borderColor: 'rgba(204, 98, 207, 1)',
            borderDash: [5, 10]
        },
        {
            label: 'Rushing For',
            data: chartData.rushingFor,
            borderColor: 'rgb(75, 192, 192)',
            borderDash: [5, 10]
        }
    ];

    useEffect(() => {
        const fetchData = async () => {
            await getTeamIDs(setTeamsList);
        }
        fetchData();
    }, []);

    const changeTeam = e =>{
        setSelectedTeam(e.target.value);
        const newTeam = e.target.value;
      
        const teamChanged = async () => {
            if (!teamsData[newTeam]?.games) {
                await getTeamSchedule(newTeam);
            
                await Promise.all(teamsData[newTeam].games.map(game => {
                    return getBoxScore(game.id, game.week.number);
                }));
            }
            
            const receivingAgainst = Object.values(teamsData[newTeam].boxStatsOppo).map(data => data.receiving.totals[1]);
            const rushingAgainst = Object.values(teamsData[newTeam].boxStatsOppo).map(data => data.rushing.totals[1]);
            const receivingFor = Object.values(teamsData[newTeam].boxStats).map(data => data.receiving.totals[1]);
            const rushingFor =  Object.values(teamsData[newTeam].boxStats).map(data => data.rushing.totals[1]);
            const chartLabels = Object.keys(teamsData[newTeam].boxStats).map(weekNum => 'Week ' + weekNum);
            setChartData({receivingAgainst, rushingAgainst, receivingFor, rushingFor, chartLabels});
            //setLatestWeek(teamsData[newTeam].latestWeek);

            setTableData({boxStats: teamsData[newTeam].boxStats, boxStatsOppo: teamsData[newTeam].boxStatsOppo});
        }

        teamChanged();
    }
    
    return <div id='footballWrapper'>
        <label htmlFor="team">Select Team: </label>
        <select name="team" onChange={changeTeam}>
            <option key="default" value="">--Select a team--</option>
            {teamsList.map(team=>{
                return <option key={team.key} value={team.key}>{team.name}</option>
            })}
        </select>
        <br/><br/>
        <label htmlFor='showFor'>Show Yards For</label>
        <input type='checkbox' id='showFor' name='showFor' checked={showFor} onChange={e=>setShowFor(e.target.checked)}/>
        <div style={{maxWidth: '75%'}}>
            {selectedTeam && <Line data={{
                labels: chartData.chartLabels,
                datasets: showFor ? [...dataSetsAgainst, ...dataSetsFor] : dataSetsAgainst
            }} options= {options} />}
        </div>
        <div id="playerData">
            {selectedTeam && <Players tableData={tableData} showFor={showFor} type="receiving" oppo={true} />}
            {selectedTeam && <Players tableData={tableData} showFor={showFor} type="rushing" oppo={true} />}
            {selectedTeam && <Players tableData={tableData} showFor={showFor} type="receiving" oppo={false} />}
            {selectedTeam && <Players tableData={tableData} showFor={showFor} type="rushing" oppo={false} />}
        </div>
    </div>
}

export default Football;